const CompanyPage = () => {
  return (
    <div>
      <h6>Company page - modal?</h6>
    </div>
  );
};

export default CompanyPage;
